import { lazy } from 'react'

export default {
    path: '/valori/:valoreId',
    title: 'Valore: {{params.valoreId}}',
    component: lazy(() => import('./detail'))
}